import { Loader2 } from "lucide-react";

type BrandSplashOverlayProps = {
  statusText: string;
};

/**
 * In-app brand splash (parity with mobile BrandSplashOverlay) + honest load status.
 */
export function BrandSplashOverlay({ statusText }: BrandSplashOverlayProps) {
  return (
    <div
      role="progressbar"
      aria-label={statusText}
      aria-busy="true"
      data-testid="brand-splash-overlay"
      className="fixed inset-0 z-[1000] flex flex-col items-center justify-center bg-[#090909] px-7"
    >
      <img
        src="/splash-icon.png"
        alt=""
        width={168}
        height={168}
        className="h-[168px] w-[168px] object-contain"
        decoding="async"
      />
      <p
        className="mt-7 text-[44px] leading-none tracking-[0.5px] text-[#F5F6F7]"
        style={{ fontFamily: "var(--font-caslon), Georgia, serif" }}
      >
        Pulse
      </p>
      <p
        className="mt-7 text-center text-sm text-[rgba(196,200,206,0.72)]"
        style={{ fontFamily: "var(--font-sans), system-ui, sans-serif" }}
      >
        Feel the pulse. Own the night.
      </p>
      <div className="mt-9 flex min-h-14 flex-col items-center gap-3.5">
        <Loader2 className="h-5 w-5 animate-spin text-[#C4C8CE]" aria-hidden />
        <p
          className="max-w-[280px] text-center text-[13px] leading-[18px] text-[rgba(196,200,206,0.78)]"
          style={{ fontFamily: "var(--font-sans), system-ui, sans-serif" }}
        >
          {statusText}
        </p>
      </div>
    </div>
  );
}
